import { render, staticRenderFns } from "./MaybankForm.vue?vue&type=template&id=4ec016c8"
import script from "./MaybankForm.vue?vue&type=script&lang=js"
export * from "./MaybankForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports